import React from 'react';

import { BaseIconProps } from './';

export const Mail = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.109375,0,0,-2.109375,0,1086.3281)"
    d="M 461,362 256,234 52,362 v 51 L 256,285 461,413 Z m 0,102 H 52 C 23,464 0,441 0,413 V 105 C 0,77 23,54 51,54 h 410 c 28,0 51,23 51,51 v 307 c 0,29 -23,52 -51,52 z"
    fill={fill}
  />
);
